// extracted by mini-css-extract-plugin
export default {"cart_total":"TotalAmountView_cart_total__aaOwj","text_red":"TotalAmountView_text_red__Iem4E","amount_description":"TotalAmountView_amount_description__zjGRH"};